<template>
  <component :is="tag" v-bind="bindings" class="album-card">
    <AppCard>
      <AppSkeleton v-if="loading" height="184px" width="100%" />
      <div v-else class="album-card__img-container">
        <CardMedia class="album-card__img" :src="album.img.src" height="184" />
      </div>

      <footer class="album-card__footer">
        <h3 class="album-card__title">
          <AppSkeleton v-if="loading" />
          <template v-else>{{ album.title }}</template>
        </h3>
      </footer>
    </AppCard>
  </component>
</template>

<script>
export default {
  name: "AlbumCard",
  props: {
    album: Object
  },
  computed: {
    loading() {
      return !this.album;
    },
    tag() {
      return this.album ? "router-link" : "div";
    },
    bindings() {
      const { album } = this;
      return album
        ? { to: { name: "album", params: { slug: album.id } } }
        : null;
    }
  }
};
</script>

<style lang="scss">
$p: ".album-card";

.album-card {
  display: block;

  &:hover {
    #{$p}__img {
      transform: scale(1.05);
    }
  }

  &__img {
    transition: transform 0.6s cubic-bezier(0.35, 0, 0, 1);
  }

  &__img-container {
    width: 100%;
    height: 184px;
    overflow: hidden;
  }

  &__footer {
    height: 78px;
    background-color: colors(palette-1);
    padding: 10px 20px;
    display: flex;
    align-items: center;
    width: 100%;
  }

  &__title {
    color: colors(palette-2);
    font-weight: fw(bold);
    @include multi-ellipsis(19, 1.3, 2);
  }

  &:hover {
    #{$p}__title {
      text-decoration: underline;
    }
  }
}
</style>
